import { styled } from '@mui/material/styles';

export const LoginContainer = styled('div')`
    height: calc(100vh - 80px - 50px);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
`;
